import { useState } from "react";
import { useUiStore } from "src/components/main/uiStore";
//------------------------------------------
import UserInfoModal from "src/components/common/userInfoModal";
import userimg from "src/img/user.png";
import { json } from "src/components/common/types";
import {
    myAxios} from "src/components/common/functions";
import { User } from "../main/authStore";
//------------------------------------------
export default function UserInfo(
    {
        name, 
        id, 
    }:{
        name: string, 
        id: string, 
    }
){
    //------------------------------------------
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const [showUserInfo, setShowUserInfo] = useState(false);
    const [u, setU] = useState<Partial<User>>({});
    //------------------------------------------
    const closeIt = () => {
        setShowUserInfo(false);
    }
    //------------------------------------------
    if(!name || !id) return <></>;
    return(
        <>
            <button
                type = "button"
                className = "headerButton noborder"
                id = {id}
                style = {{
                    color: "blue", 
                    cursor: "pointer"
                }}
                onClick = {async () => {
                    const formData = new FormData();
                    formData.append("id", id);
                    //-------------------------------------------------------------
                    setShowLoader(true);
                    const res: false | json = await myAxios({ fileName: "common/readUserInfo.php", formData: formData });
                    setShowLoader(false);
                    if(!res) return;
                    //-------------------------------------------------------------
                    if(res.data.profileUrl){
                        setU(res.data);
                    }else{
                        setU({
                            ...res.data, 
                            profileUrl: userimg
                        });
                    }
                    setShowUserInfo(true);
                }}
            >
                {name}
            </button>
            {showUserInfo?
            <UserInfoModal
                user = {u}
                closeIt = {closeIt} 
            />:null}
        </>
    )
}